import React from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { TEXTS, STYLED_CONSTANTS } from "./constant";
import {
    Container,
    ContentContainer,
    ButtonContainer,
    FlexCta,
    TitleText,
    DescriptionText,
} from "./styled";
import { IMultiVariantRemovePromptProps } from "./types";

const MultiVariantRemovePrompt: React.FC<IMultiVariantRemovePromptProps> = ({
    isOpen,
    onCancel,
    onViewCart,
}) => {
    return (
        <HalfCard
            isOpen={isOpen}
            hasCustomPadding
            onClose={onCancel}
            hideCloseIcon
            backgroundColor="background_Primary"
        >
            <Container>
                <ContentContainer>
                    <TitleText variant="V2.body1.neutral.bold">{TEXTS.TITLE}</TitleText>
                    <DescriptionText variant="V2.body2.neutral.regular">
                        {TEXTS.DESCRIPTION}
                    </DescriptionText>
                </ContentContainer>

                <ButtonContainer>
                    <FlexCta>
                        <SuperButton
                            buttonType="secondary"
                            buttonSize={STYLED_CONSTANTS.BUTTON_SIZE}
                            onClick={onCancel}
                        >
                            {TEXTS.CANCEL}
                        </SuperButton>
                    </FlexCta>

                    <FlexCta>
                        <SuperButton
                            buttonType="primary"
                            buttonSize={STYLED_CONSTANTS.BUTTON_SIZE}
                            onClick={onViewCart}
                        >
                            {TEXTS.VIEW_CART}
                        </SuperButton>
                    </FlexCta>
                </ButtonContainer>
            </Container>
        </HalfCard>
    );
};

export default React.memo(MultiVariantRemovePrompt);
